import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

type ButtonSelectProps = {
  $error: boolean;
};

export const ButtonSelect = styled.button<ButtonSelectProps>`
  display: flex;
  padding: 16px;
  background: ${ColorPalette.HEX.White};
  border: 1px solid ${({ $error, theme }) => ($error ? theme.input.errorColor : theme.rulesComponent.lightGrey)};
  width: 100%;
  height: 48px;
  text-align: inherit;
  border-radius: 8px;
  cursor: pointer;

  &:disabled {
    background: ${ColorPalette.HEX.Cultured6};
  }

  & > svg {
    align-self: center;
    font-size: 18px;
  }
`;

export const Text = styled.span`
  font-size: 16px;
  flex: 1;
`;

export const Error = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.input.errorColor};
`;
